import * as React from "react";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import PropTypes from "prop-types";
import { cn } from '../../utils/lib/utils';

const ScrollArea = React.forwardRef(function ScrollArea(
  { className, children, ...props },
  ref
) {
  return (
    <ScrollAreaPrimitive.Root
      ref={ref}
      className={cn("relative overflow-hidden", className)}
      {...props}
    >
      <ScrollAreaPrimitive.Viewport className="h-full w-full rounded-[inherit]">
        {children}
      </ScrollAreaPrimitive.Viewport>
      <ScrollBar />
      <ScrollAreaPrimitive.Corner />
    </ScrollAreaPrimitive.Root>
  );
});

ScrollArea.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const ScrollBar = React.forwardRef(function ScrollBar(
  { className, orientation = "vertical", ...props },
  ref
) {
  return (
    <ScrollAreaPrimitive.ScrollAreaScrollbar
      ref={ref}
      orientation={orientation}
      className={cn(
        "flex touch-none select-none transition-colors",
        orientation === "vertical" &&
          "h-full w-2.5 border-l border-l-transparent p-[1px]",
        orientation === "horizontal" &&
          "h-2.5 border-t border-t-transparent p-[1px]",
        className
      )}
      {...props}
    >
      <ScrollAreaPrimitive.ScrollAreaThumb className="relative flex-1 rounded-full bg-slate-200" />
    </ScrollAreaPrimitive.ScrollAreaScrollbar>
  );
});

ScrollBar.propTypes = {
  className: PropTypes.string,
  orientation: PropTypes.oneOf(["vertical", "horizontal"]),
};

export { ScrollArea, ScrollBar };
